module.exports = __webpack_public_path__ + "img/ch.cf2ee9ce.svg";